import { usePunditUserContext } from "@circle-react/contexts/punditUserContext";
import { useUnreadChatRoomsStore } from "@circle-react/hooks/chatsV2/store";
import { isNull } from "lodash";

export const useUnreadChatRoomUuids = ({
  communityId: communityIdParam,
}: any) => {
  const { currentCommunity } = usePunditUserContext();
  const communityId = communityIdParam || currentCommunity?.id;
  const { unreadChatRoomUuids } = useUnreadChatRoomsStore();

  if (isNull(communityId)) return [];
  return unreadChatRoomUuids[communityId] || [];
};
